import axios from 'axios'
import router from '../../router'
const state = {
  mDocumentList: [],
  documentRtn: ''
}

const getters = {
  getDocumentList (state) {
    return state.mDocumentList
  },
  getTranDocument (state) {
    return state.documentRtn
  }
}

const mutations = {
  setDocumentList (state, payload) {
    state.mDocumentList = payload
  },
  setTranDocumentRtn (state, payload) {
    state.documentRtn = payload
  }
}

const actions = {
  apiDocumentList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getDocSearch', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setDocumentList', response.data)
          if (response.data.length > 0) {
            // context.commit('setRecommandItem', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          } else {
            // console.log()
            alert(error.response)
          }
        })
    }
  },
  apiTranDocument (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranDocList', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setTranDocumentRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            }
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/documentmanagement.js